import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createKeka } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  return Object.fromEntries(
    Object.entries(values).filter(
      ([_, value]) => value !== "" && value !== undefined && value !== null,
    ),
  );
}

export function useCreateKeka() {
  return useMutation({
    mutationFn: async ({ item }) => {
      const payload = buildPayload(item);
      return createKeka({ item: payload });
    },
    onSuccess: () => {
      toast.success("Keka Connected Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
